export const progress = [
  {
    label: 'Created',
    value: 1,
  }, {
    label: 'Completed',
    value: 2,
  }, 
]
